import { createAxiosInstance } from './axios-setup';
import { debugLogger } from '../helpers/debugLogger.js';
import { errorLogger } from '../helpers/errorLogger.js';

const api = createAxiosInstance()

api.getCartSuggestions = async (cartUUID) => {
  try {
    const response = await api.get(Drupal.url(`api/cart-suggestions/${cartUUID}`), {
      params: {
        _format: 'json'
      },
      headers: {
        'Accept': 'application/json'
      }
    });

    debugLogger('Cart suggestions: ', response.data)

    return response.data
  } catch (error) {
    errorLogger('Error fetching suggestions for cart: ', error);
    return null;
  }
}

api.getPaymentOptions = async (cartUUID) => {
  try {
    const response = await api.get(Drupal.url(`api/payments-options/${cartUUID}`), {
      params: {
        _format: 'json'
      },
      headers: {
        'Accept': 'application/json'
      }
    });

    debugLogger('Payment options: ', response.data)

    return response.data
  } catch (error) {
    errorLogger('Error fetching payment options for cart: ', error);
    return null;
  }
}

api.setOrderItemPrice = async (itemUUID, price) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    }
    const params = {
      _format: 'json'
    }
    const url = Drupal.url(`api/order-item-price/${itemUUID}`);
    const payload = {
      price: Number(price)
    };

    const response = await api.patch(url, payload, { headers, params });

    debugLogger('New price set: ', response.data)

    return response.data
  } catch (error) {
    errorLogger('Error setting new price: ', error);
    return null;
  }
}

api.setOrderStateToValidation = async (cartUUID) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    }
    const params = {
      _format: 'json'
    }
    const url = Drupal.url(`api/payment/${cartUUID}`);

    const response = await api.get(url, { headers, params });

    debugLogger('Order state changed to validation: ', response.data)

    return response.data
  } catch (error) {
    errorLogger('Error changing order state: ', error);
    return null;
  }
}

api.fetchCertificatesToGenerate = async (orderUUID) => {
  try {
    const response = await api.get(Drupal.url(`api/certificates/${orderUUID}`), {
      params: {
        _format: 'json'
      },
      headers: {
        'Accept': 'application/json'
      }
    });

    debugLogger('Certificate data from order: ', response.data)

    return response.data
  } catch (error) {
    // don't log error here, there can be retry going
    return null;
  }
}


api.fetchGeneratedCertificate = async (licenseUUID) => {
  try {
    const response = await api.get(Drupal.url(`api/certificates/generate/${licenseUUID}`), {
      params: {
        _format: 'json'
      },
      headers: {
        'Accept': 'application/json'
      }
    });

    debugLogger('Certificate data from order: ', response.data)

    return response.data
  } catch (error) {
    // don't log error here, there can be retry going
    return null;
  }
}

api.fetchCertificateDataFromOrder = async (orderUUID) => {
  try {
    const response = await api.get(Drupal.url(`api/certificates/printer/${orderUUID}`), {
      params: {
        _format: 'json'
      },
      headers: {
        'Accept': 'application/json'
      }
    });

    debugLogger('Certificate data from order: ', response.data)

    return response.data
  } catch (error) {
    // don't log error here, there can be retry going
    return null;
  }
}

api.fetchDonations = async () => {
  try {
    const response = await api.get(Drupal.url(`api/donations/`), {
      params: {
        _format: 'json'
      },
      headers: {
        'Accept': 'application/json'
      }
    });

    debugLogger('Donations: ', response.data)

    return response.data
  } catch (error) {
    errorLogger('Error fetching donations: ', error);
    return null;
  }
}

api.fetchDonation = async (UUID) => {
  try {
    const response = await api.get(Drupal.url(`api/donation/${UUID}`), {
      params: {
        _format: 'json'
      },
      headers: {
        'Accept': 'application/json'
      }
    });

    debugLogger('Donation: ', response.data)

    return response.data
  } catch (error) {
    errorLogger('Error fetching donation: ', error);
    return null;
  }
}

api.fetchDonationCertificates = async (UUID) => {
  try {
    const response = await api.get(Drupal.url(`api/donation/certificates/${UUID}`), {
      params: {
        _format: 'json'
      },
      headers: {
        'Accept': 'application/json'
      }
    });

    debugLogger('Donation certificates: ', response.data)

    return response.data
  } catch (error) {
    // errorLogger('Error fetching donation certificates: ', error);
    return null;
  }
}

api.fetchCertificatesToGenerateFromDonation = async (UUID) => {
  try {
    const response = await api.get(Drupal.url(`api/donation/certificates/candidates/${UUID}`), {
      params: {
        _format: 'json'
      },
      headers: {
        'Accept': 'application/json'
      }
    });

    debugLogger('Donation certificates: ', response.data)

    return response.data
  } catch (error) {
    // errorLogger('Error fetching donation certificates: ', error);
    return null;
  }
}

export { api }
